var map = {
	"./academy.svg": 4794,
	"./cup.svg": 3842,
	"./digital.svg": 2584,
	"./education.svg": 8374,
	"./esg.svg": 172,
	"./female-2.svg": 2136,
	"./female.svg": 6311,
	"./hand-shaking.svg": 8513,
	"./hande-leave.svg": 9259,
	"./increase-2.svg": 5014,
	"./increse.svg": 4255,
	"./mony.svg": 387,
	"./recycle.svg": 106,
	"./rocket.svg": 5986,
	"./social-2.svg": 4510,
	"./two-hands.svg": 1753
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2601;